module.exports = __webpack_public_path__ + "img/no 12.ff89a9fe.png";